import { useErrorHandler } from 'components/error'
import { confirm } from 'components/modals/confirm'
import { useExcluirGrupoParticipanteAtividadeColetivaMutation } from 'graphql/hooks.generated'
import { useCallback } from 'react'

import { MSG_EXCLUSAO_GRUPO_AC_MODAL } from '../utils-atividadeColetivaGrupos'

interface UseAtividadeColetivaGruposExcluirOptions {
  onSuccess?: () => void
}

export function useAtividadeColetivaGruposExcluir(options: UseAtividadeColetivaGruposExcluirOptions) {
  const { onSuccess } = options
  const handleRejection = useErrorHandler()
  const [excluirGrupoMutation] = useExcluirGrupoParticipanteAtividadeColetivaMutation()

  const excluirGrupo = useCallback(
    (grupoId: string) => {
      confirm({
        title: 'Deseja excluir o grupo?',
        confirmLabel: 'Excluir',
        type: 'danger',
        body: MSG_EXCLUSAO_GRUPO_AC_MODAL,
        onConfirm: () =>
          excluirGrupoMutation({ variables: { grupoParticipanteAtividadeColetivaId: grupoId } })
            .then(() => onSuccess?.())
            .catch(handleRejection),
      })()
    },
    [excluirGrupoMutation, handleRejection, onSuccess]
  )

  return { excluirGrupo }
}
